// extracted by mini-css-extract-plugin
export default {"container":"TangramTableItem-module__container___x9IH5","tangram":"TangramTableItem-module__tangram____ilDP","name":"TangramTableItem-module__name___tcDi6"};